import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

// Renders a generic warning icon for low-resolution indications.
const PhotoLowResolutionIcon = ({ className, ...props }) => (
  <div
    className={classNames(
      'd-md-flex align-items-center text-center dpi-notice__container',
      className,
    )}
    role="img"
    {...props}>
    <span className="dpi-notice__icon" aria-hidden="true">
      <span>!</span>
    </span>
  </div>
);

PhotoLowResolutionIcon.propTypes = {
  className: PropTypes.string,
  'aria-label': PropTypes.string,
};

PhotoLowResolutionIcon.defaultProps = {
  className: 'dpi-notice',
  'aria-label': '',
};

export default PhotoLowResolutionIcon;
